export const validation = {
  receipt: {
    max_chars_8: 'It must contain at most 8 characters',
    max_chars_50: 'It must contain at most 50 characters',
    max_number_1000: 'The maximum value must be 1000',
    min_number_0: 'The minimum value must be zero',
    maxTwoDecimals: 'It must contain at most 2 decimals',
  },
};
